export const MeetingType = {
	ONE_ON_ONE: "one_on_one",
	GROUP: "group",
} as const;
export type MeetingType = (typeof MeetingType)[keyof typeof MeetingType];

export const MeetingFormat = {
	ONLINE: "online",
	IN_PERSON: "in_person",
	HYBRID: "hybrid",
} as const;
export type MeetingFormat = (typeof MeetingFormat)[keyof typeof MeetingFormat];

export const MeetingStatus = {
	PUBLISHED: "published",
	CANCELLED: "cancelled",
} as const;
export type MeetingStatus = (typeof MeetingStatus)[keyof typeof MeetingStatus];

export const MeetingAttendeeStatus = {
	PENDING: "pending",
	REGISTERED: "registered",
	DECLINED: "declined",
} as const;
export type MeetingAttendeeStatus = (typeof MeetingAttendeeStatus)[keyof typeof MeetingAttendeeStatus];

export const MeetingAudience = {
	ENTIRE: "entire",
	GROUPS: "groups",
	MEMBERS: "members",
} as const;
export type MeetingAudience = (typeof MeetingAudience)[keyof typeof MeetingAudience];

export const MeetingAudienceFilter = {
	ALL: "all",
	REGISTERED: "registered",
} as const;
export type MeetingAudienceFilter = (typeof MeetingAudienceFilter)[keyof typeof MeetingAudienceFilter];

export const MeetingTimeFilter = {
	UPCOMING: "upcoming",
	PAST: "past",
} as const;
export type MeetingTimeFilter = (typeof MeetingTimeFilter)[keyof typeof MeetingTimeFilter];

export const MeetingVisibility = {
	PUBLIC: "public",
	PRIVATE: "private",
} as const;
export type MeetingVisibility = (typeof MeetingVisibility)[keyof typeof MeetingVisibility];

export const MeetingExternalGuestStatus = {
	PENDING: "pending",
	ACCEPTED: "accepted",
	DECLINED: "declined",
} as const;
export type MeetingExternalGuestStatus = (typeof MeetingExternalGuestStatus)[keyof typeof MeetingExternalGuestStatus];
